import {
    SET_PRESEIZURE_PACKAGE_VIEW,
    SET_PRESEIZURE_PACKAGE_LOADING,
    SET_PRESEIZURE_PACKAGE_FIELD_LOADING,
    UPDATE_PRESEIZURE_PACKAGE_FIELD,
    SET_PRESEIZURE_PACKAGE_BUDGET_DATA,
    SET_PRESEIZURE_PACKAGE_DROPDOWNS,
    SET_PRESEIZURE_PACKAGE_NEEDS_OLI_RESUBMISSION
} from "../types";

const initialState = {
    budget_data: {},
    data: {},
    lists: {},
    view: {}
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case UPDATE_PRESEIZURE_PACKAGE_FIELD:
            return {
                ...state,
                data: { ...payload }
            };
        case SET_PRESEIZURE_PACKAGE_NEEDS_OLI_RESUBMISSION:
            return {
                ...state,
                data: {
                    needs_oli_resubmission: payload
                }
            };
        case SET_PRESEIZURE_PACKAGE_VIEW:
            return {
                ...state,
                data: {
                    ...payload.data
                },
                view: {
                    ...state.view,
                    ...payload,
                    // skeleton: payload.skeleton,
                    dropdowns: payload.dropdowns
                    // validation_rules: payload.validation_rules
                }
            };
        case SET_PRESEIZURE_PACKAGE_BUDGET_DATA:
            return {
                ...state,
                budget_data: {
                    ...payload
                }
            };
        case SET_PRESEIZURE_PACKAGE_DROPDOWNS:
            return {
                ...state,
                view: {
                    ...state.view,
                    dropdowns: payload
                }
            };
        case SET_PRESEIZURE_PACKAGE_FIELD_LOADING:
            return {
                ...state,
                view: {
                    ...state.view,
                    field_loading: payload.loading
                }
            };
        default:
            return state;
    }
}
